// Utility functions for safe config access with fallbacks
// Use these when you can't use hooks (e.g., in utility functions)

export const getSafeDateTime = (dateTime: string, showTime: boolean = false, options: any = {zone: 'utc'}): string => {
    if (!dateTime) {return '';}
    
    // Use window.DCONSTANTS with fallback
    const format = window.DCONSTANTS?.datetimeFormat || 'yyyy-LL-dd HH:mm:ss';
    
    try {
        // Import dynamically to avoid circular dependencies
        const isoTimeToLocal = require('./date').default;
        return isoTimeToLocal(dateTime, showTime, format, options);
    } catch (error) {
        console.warn('Date formatting error:', error);
        return dateTime;
    }
};

export const getSafeConfig = () => {
    return {
        sessionTime: Number(window.DCONSTANTS?.sessionTime) || 14400,
        datetimeFormat: window.DCONSTANTS?.datetimeFormat || 'yyyy-LL-dd HH:mm:ss',
        maxChartLegendLabelsShown: Number(window.DCONSTANTS?.maxChartLegendLabelsShown) || 40,
        monitorLastDays: Number(window.DCONSTANTS?.monitorLastDays) || 60,
        warningTime: Number(window.FCONST?.FS_SESSION_EXPIRY_WARNING_TIME_IN_SECONDS) || 300
    };
};

// Safe request configuration for Bottleneck limiter
// Uses the loaded config after login instead of fallback defaults
export const getSafeRequestConfig = () => {
    // Use the loaded config values (available after login)
    const maxConcurrentRaw = window.FCONST?.FS_FRONTEND_MAX_CONCURRENT_REQUESTS;
    const maxConcurrentNumber = Number(maxConcurrentRaw);
    const maxConcurrent = (maxConcurrentRaw && !isNaN(maxConcurrentNumber) && maxConcurrentNumber > 0)
        ? maxConcurrentNumber
        : 10; // Fallback to config default

    const minTimeRaw = window.FCONST?.FS_FRONTEND_MIN_TIME_BETWEEN_REQUESTS_IN_MS;
    const minTimeNumber = Number(minTimeRaw);
    const minTime = (minTimeRaw && !isNaN(minTimeNumber) && minTimeNumber >= 0)
        ? minTimeNumber
        : 25; // Fallback to config default

    return {maxConcurrent, minTime};
};

// Get request config that updates when config is loaded
export const getUpdatedRequestConfig = () => {
    // This will use the actual loaded config values after login
    return getSafeRequestConfig();
};

// Check if config is loaded (including empty DCONSTANTS)
export const isConfigLoaded = (): boolean => {
    return !!(window.DCONSTANTS !== undefined);
};
